export default __webpack_public_path__ + "static/media/privacy.95293b43.jpg";